export default "__VITE_ASSET__110cbf66__"